import React from 'react';
import { theme, useResponsive, VStack } from '@sg/garnish';

import { useLocalizationContext } from '@order/Localization';

import {
  AccountScreenContainer,
  AccountScreenSection,
  AccountScreenTitle,
} from '../AccountScreenContainer';
import { SkeletonLoadingContent } from './AccountSkeletonLoading';

export const AccountOrdersLoading = () => {
  const { match } = useResponsive();
  const { t } = useLocalizationContext();

  return (
    <AccountScreenContainer screen="orders">
      <AccountScreenTitle title={t('account.orders.title')} />

      <AccountScreenSection>
        <VStack gap={match([theme.spacing[4], theme.spacing[6]])}>
          {/* Orders */}
          <SkeletonLoadingContent rowHeight={ORDER_CARD_HEIGHT} />
          <SkeletonLoadingContent rowHeight={ORDER_CARD_HEIGHT} />
          <SkeletonLoadingContent rowHeight={ORDER_CARD_HEIGHT} />
          <SkeletonLoadingContent rowHeight={ORDER_CARD_HEIGHT} />
          <SkeletonLoadingContent rowHeight={ORDER_CARD_HEIGHT} />
        </VStack>
      </AccountScreenSection>
    </AccountScreenContainer>
  );
};

// ─── Constants ───────────────────────────────────────────────────────────────

const ORDER_CARD_HEIGHT = 170;
